import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Params, Router, NavigationEnd  } from '@angular/router';
import { Subscription, Observable, Subject, filter, map } from 'rxjs';
import { XAPIDataGenerator } from 'libs-frontend-xapi/dist/js/xapidatagenerator.js';

import { ProductViewV4 } from '../product-view-v4/product-view-v4.component';

import { ApiGatewayHelperService } from './../../../app/services/apigateway-helper.service';
import { ProductViewHelperService } from './../../services/product-view-helper.service';
import { ProductViewDataService } from './../../services/product-view-data.service';
import { CanComponentDeactivate } from './../../services/can-deactivate-lp-guard.service';
import { LoaderService } from '../../../app/services/loader.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { AuthService } from 'modules/app/services/auth.service';
import { ProductTocService } from './../../services/product-toc.service';
import { LtiHelperService } from 'modules/teacher/services/lti-helper.service';
import { TrackUserService } from './../../services/track-user-service';

import { HtmlMetaManagerService } from '../../../app/services/html-meta-manager.service';
import translations from './../../../../assets/i18n/en';
import { ContentHelper } from 'libs-content-helper';
import { ltiToolRefs } from '../../../shared-all/constants/lti.constants';
import { UserSettingsService } from 'modules/shared-postlogin/services/user-settings.service';
import { CustomBackendLoggerService } from 'modules/app/services/custom-backend-logger.service';
import { ThemeService } from "libs-frontend-micro-base";

@Component({
    selector: 'product-view',
    templateUrl: './product-view.template.html',
    styleUrls: ['./product-view.style.scss'],
    standalone: false
})
export class ProductView implements OnInit, CanComponentDeactivate {
    @ViewChild('launchNextActivityBtn') launchNextActivity : ElementRef;
    @ViewChild(ProductViewV4) private readonly productViewV4: ProductViewV4;
    learningpathVisible: boolean = false;
    isPreviewMode: boolean;
    productTocData: any;
    tocArray: any;
    assignmentData: any;
    paramsSubscription: Subscription;
    productCode : string;
    classId: string;
    assignmentId: string;
    productMeta: any;
    selectedItemSubscription: Subscription;
    selectedItem : any = {};
    selectedItemData : any;
    xapiLOAnalytics: any;
    previewMode : string;
    previewStage : string;
    appState: any;
    nextActivityBtn = {
        show: false,
        isSecondary: false,
        type: 'nextActivity' as 'nextActivity' | 'backToAssignments'
    };
    userProfileData: any;
    disableNextQuestionBtn = false;
    bundleDetails : any;
    showResultScreenEvent:Subject<any> = new Subject();
    assignmentReviewMode : boolean = false;
    public accessibleUnitCode: string = '';
    public accessibleActivityId: string = '';
    public scoreType: 'bestScore' | 'firstScore' = 'bestScore';
    public isLPv4Product: boolean = false;
    public isActivityLaunched: boolean = false;
    private childParamsSubscription: Subscription;
    private readonly themeService: any;
    public isTeacherViewAssignment: boolean = false;
    public isLearnerViewAssignment: boolean = false;

    /* Boolean to show/hide result screen */
    showResultScreen: boolean = false;
    /* Boolean to determine if current selected activity is game - needed to hide header and controls */
    isGameActivity: boolean = false;
    /* Boolean to show/hide back btn in ToC */
    showComponentBackBtn: boolean = false;

    /* Array to contain all the content controls visible */
    showControls = [];
    userData: any;
    userSettingsData: any;
    isLitmusAvailable: boolean = true;
    showLitmusUnavailableScreen: boolean = false;

    constructor(
        private route: ActivatedRoute, 
        private router: Router,
        private productViewHelperService: ProductViewHelperService,
        private loaderService: LoaderService,
        private appHelperService: AppHelperService,
        private apiGatewayHelperService : ApiGatewayHelperService, 
        private productViewDataService : ProductViewDataService,
        private chRef: ChangeDetectorRef,
        private authService: AuthService,
        private htmlMetaManagerService : HtmlMetaManagerService,
        private productTocService: ProductTocService,
        private ltiHelperService: LtiHelperService,
        private userSettingsService: UserSettingsService,
        private trackUserService: TrackUserService,
        private readonly customBackendLoggerService: CustomBackendLoggerService
    ) {
        this.themeService = new ThemeService();
    }

    ngOnInit() {
        this.loaderService.hideLoader();
        this.previewMode = this.route.snapshot.queryParamMap.get('preview');
        this.previewStage = this.route.snapshot.queryParamMap.get('stage');
        this.userData = this.authService.getUserData();
        this.authService.logoutTriggered.subscribe(() => {
            // Removed xapiLOAnalytics object so that no analytics call is made when user is leaves product-view component
            this.xapiLOAnalytics = undefined;
        });
        // Product TOC data
        this.productTocData = this.route.snapshot.data.resolveData.productData;
        this.userProfileData = this.route.snapshot.data.resolveData.userProfileData;
        this.userSettingsData = this.route.snapshot.data.resolveData.userSettingsData;
        let olpProduct = this.productTocData.bundleDetails.products.find((product)=> {
            return product['ext-product'].type === 'OLP'
        })
        this.scoreType = this.productTocData.classmeta?.analytics_score_aggregation_type === 'first' ? 'firstScore' : 'bestScore';

        /*  If previewMode, open product in previewMode 
            If user is a teacher and product is not a training product, open in PreviewMode
            If user is a teacher and Progress Tracking for Teachers not true, open in PreviewMode 
        */
        if (
            this.previewMode ||
            (
                this.router.url?.indexOf("/teacher/") !== -1 &&
                !(this.productTocData?.bundleDetails?.target?.role === 'teacher' && olpProduct?.analytics?.teacher === true)
            )
        ) {
            this.isPreviewMode = true;
            this.productViewHelperService.setIsPreviewMode(true);
        } else {
            this.isPreviewMode = false;
            this.productViewHelperService.setIsPreviewMode(false);
        }

        if(this.router.url && this.router.url.indexOf('/review-assignment/') !== -1){
            this.assignmentReviewMode = true;
        }

        this.paramsSubscription = this.route.params.subscribe((params: Params) => {
            // CLear previous TOC data
            this.productCode = params.productcode;
            this.classId = params.classid;
            this.assignmentId = params.assignmentid;
            this.accessibleUnitCode = params.unitcode;
            this.accessibleActivityId = params.activityId;
            this.isTeacherViewAssignment = this.assignmentId && this.userProfileData?.role !== 'student';
            this.isLearnerViewAssignment = this.assignmentId && this.userProfileData?.role === 'student';

            // Make classId undefined if Class is expired, so that the component behaves like it does with private learning
            if(this.productTocData?.classmeta?.class?.enddate && new Date(this.productTocData.classmeta.class.enddate) < new Date()) {
                this.classId = undefined;
            }

            this.tocArray = this.productTocData.toc.tocArray;
            this.productMeta = this.productTocData.meta.meta;
            this.bundleDetails = this.productTocData.bundleDetails;

            // back btn will be hidden for builder preview and learner
            this.showComponentBackBtn = !(this.router.url.indexOf("/learner/") > -1 || this.route.snapshot.queryParamMap.get('preview') === "true");

            if(params.assignmentid) {
                this.assignmentData = this.productTocData.assignmentData;
            }

            // Keep only the accessibleActivityId in the navigationMeta so that next button is not shown on activity completion 
            if(this.accessibleUnitCode && this.accessibleActivityId) {
                this.productTocData.toc.navigationMeta = this.productTocData.toc.navigationMeta.filter((item)=> {
                    return this.accessibleActivityId === item["item-code"]; 
                })
            }

            this.htmlMetaManagerService.setTitle(translations.HTML_META.LEARNINGPATH.TITLE, this.bundleDetails.title);
            this.htmlMetaManagerService.setDescription(translations.HTML_META.LEARNINGPATH.DESCRIPTION);

            let productResultsDisplayData = {};
            const bundleProduct = this.bundleDetails.products.find( (bP) => bP['dls-product']['code'] === this.productCode);
            const isTestTypeProduct = this.productViewHelperService.isTestTypeComponent(bundleProduct);
            if (bundleProduct?.['results-display']) {
                productResultsDisplayData = bundleProduct['results-display'];
            }

            // Check if the current product is LPv4 product
            if (bundleProduct['learning-path']?.version === '4') {
                this.isLPv4Product = true;
                // For LPv4 products, we don't need the learning path sidebar except for teacher view assignment
                this.learningpathVisible = !!this.isTeacherViewAssignment;

                if (this.assignmentId) {
                    this.isActivityLaunched = true;
                }

                // Set the segment for LPv4 products
                !this.isTeacherViewAssignment && this.themeService.activateThemeOnComponent(bundleProduct?.segment ? bundleProduct.segment.segment : 'adult', 'product-view');

                // Set activity launch flag to true for LPv4 products if user navigates directly to an activity
                if (this.route.firstChild?.snapshot.params?.itemid) {
                    this.isActivityLaunched = true;
                }
            }

            if (!isTestTypeProduct && (!this.isLPv4Product || this.isTeacherViewAssignment) && !this.previewMode) {
                if(this.userSettingsService.isHideTOCOnLaunch(this.userSettingsData)){
                    this.learningpathVisible = false;  
                    this.userSettingsService.setShowTOCOnLaunchForFirstVisit(false);
                }else{
                    this.learningpathVisible = true;
                    this.userSettingsService.setShowTOCOnLaunchForFirstVisit(true);
                    this.userSettingsService.init(this.apiGatewayHelperService.getSpaceId());
                    this.userSettingsService.saveTOCSettingsForUser({classId: this.classId, orgId: this.productTocData.orgId, productCode: this.productCode});
                }
            }

            this.productViewHelperService.setProductClass(this.productCode, params.classid,
                this.productTocData.classmeta, productResultsDisplayData, isTestTypeProduct);

            this.appState = this.productTocData.appState;

            //ANALYTICS - Setup initialization params & initialize analytics engine.
            const routePrefix = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
            const serverRoutePrefix = routePrefix.substring(0, routePrefix.length - 1);

            //Setup initialization params
            const initParams = {
                paths: {
                    dependencyBase: window.location.protocol + '//' + window.location.host + MICROAPP_BASE_URL + 'node_modules',
                    contentAssetBase: this.productMeta.paths["public-assets"]
                },
                serverRoutePrefix: !this.isPreviewMode && serverRoutePrefix,
                userId: this.userProfileData.extUserId,
                productCode: this.productCode,
                isTestTypeProduct,
                userRole: this.userProfileData.role,
                userFirstName: this.userProfileData.firstName,
                orgId: this.productTocData.orgId,
                classId: this.classId,
                isCBPClass: this.productViewHelperService.getIsCBPClass(),
                spaceId: this.apiGatewayHelperService.getSpaceId(),
                segment: ((this.userProfileData.role === 'student' || this.isLPv4Product) &&
                    bundleProduct?.segment ? bundleProduct.segment.segment : 'adult')
            };

            //In case of teacher reviewing generic-lti type activity of a learner
            if (params.userid && this.productTocData?.learnerData) {
                initParams.userId = this.productTocData.learnerData.ext_user_id;
            }

            this.productViewHelperService.setXAPIAnalyticsObject({
                    serverRoutePrefix,
                    dlsProductCode: this.productCode, 
                    isTestTypeProduct,
                    spaceId: this.apiGatewayHelperService.getSpaceId(),
                    orgId: this.productTocData.orgId,
                    dlsClassId: this.classId,
                    isCBPClass: this.productViewHelperService.getIsCBPClass(),
                    dlsAssignmentId: this.assignmentId,
                    userId: this.userProfileData.extUserId,
                    userProgressAnalytics: this.productTocData.toc.navigationMeta
            });

            // Setup event handlers for receiving events from LO.
            this.xapiLOAnalytics = this.productViewHelperService.getXAPIAnalyticsObject();

            const eventCallbacks = {
                newState: (uniqueId, newState) => {
                    //Persist state to LRS via analytics engine if user is not a teacher
                    if (this.xapiLOAnalytics && !this.isPreviewMode) {
                        this.xapiLOAnalytics.postState(uniqueId, newState);
                    }
                },
                newInterpretedStatements: (uniqueId, newInterpretedStatements) => {
                    // Ignore statements in case user is a teacher
                    if (this.isPreviewMode) {
                        return;
                    }

                    const unitId = this.selectedItem.unitId;
                    const lessonId = this.selectedItem.lessonId;
                    const activityId = this.selectedItem.activityId;
                    const courseToc = this.productTocData.toc.tocObject;
                    let verb;
                    let groupId;

                    let selectedUnit;
                    let selectedLesson;
                    let selectedActivity;

                    let foundCompletedStatement = false;

                    try {
                        if (unitId && lessonId) {
                            selectedUnit = courseToc[unitId];
                            selectedLesson = selectedUnit?.items[lessonId];
                        }
                        else if (lessonId) {
                            selectedLesson = courseToc[lessonId];
                        }
                        selectedActivity = this.selectedItemData;

                        for (let i = 0; i < newInterpretedStatements.length; i++) {
                            if (newInterpretedStatements[i]?.json?.verb?.id) {
                                verb = newInterpretedStatements[i].json.verb.id;
                                if (newInterpretedStatements[i].json?.group) {
                                    groupId = newInterpretedStatements[i].json.group.id;
                                }
                                if (verb.indexOf("launched") !== -1) {
                                    this.productViewHelperService.addActivityTiming(activityId, 'launchTs',
                                        new Date(newInterpretedStatements[i].json.timestamp).getTime());
                                    if (newInterpretedStatements[i]?.json?.object?.id !== activityId) {
                                        // If launched statement of previous LO is called after the user has changed the LO, ignore that status
                                        return;
                                    }
                                    if (selectedActivity) {
                                        if (selectedActivity.__analytics.status != 'in_complete') {
                                            this.tocArray.__analytics.itemsCount.inComplete++;
                                            if (selectedActivity.__analytics.status == 'completed') {
                                                this.tocArray.__analytics.itemsCount.completed--;
                                            }
                                        }

                                        selectedActivity.__analytics.status = 'in_complete';
                                        if (!this.accessibleUnitCode && !this.isLPv4Product) {
                                            if (this.assignmentId) {
                                                this.appState['recentlyAccessedItem-' + this.assignmentId] = activityId;
                                            } else {
                                                this.appState.recentlyAccessedItem = activityId;
                                            }
                                            this.productViewDataService.updateAppState(this.productCode, this.appState, params.classid, this.productViewHelperService.getIsCBPClass(), isTestTypeProduct).subscribe();
                                        }
                                    }
                                } else if (verb.indexOf("completed") !== -1) {
                                    this.logInfoToBackend('TYPE=ACTIVITY_COMPLETION;MicroAPP');
                                    foundCompletedStatement = true;
                                    if (newInterpretedStatements[i].json?.object?.id !== activityId) {
                                        // If completed statement of previous LO is called after the user has changed the LO, ignore that status
                                        this.productViewHelperService.addActivityTiming(newInterpretedStatements[i].json.object.id, 'completeTs',
                                            new Date(newInterpretedStatements[i].json.timestamp).getTime());
                                        this.logInfoToBackend('TYPE=ACTIVITY_COMPLETION_ERROR;MicroAPP', {
                                            newInterpretedStatements,
                                            statementIndexWithWrongId: i,
                                            timings: this.productViewHelperService.getActivityTiming(newInterpretedStatements[i].json.object.id),
                                        });
                                        // Clean up the item timing map
                                        this.productViewHelperService.deleteActivityTiming(newInterpretedStatements[i].json.object.id);
                                        return;
                                    }
                                    // Clean up the item timing map
                                    this.productViewHelperService.deleteActivityTiming(newInterpretedStatements[i].json.object.id);
                                    if (selectedActivity) {
                                        this.tocArray.__analytics.itemsCount.completed++;
                                        this.tocArray.__analytics.itemsCount.inComplete--;
                                        selectedActivity.__analytics.completedCountOverall += 1;
                                        selectedActivity.__analytics.status = 'completed';

                                        if (selectedActivity["sub-type"] === "ext-cup-xapiscoreable") {
                                            if (selectedActivity.__analytics?.bestResult) {
                                                if (selectedActivity.__analytics.bestResult.scaledScore !== undefined) {
                                                    if (newInterpretedStatements[i].json.result.score.scaled > selectedActivity.__analytics.bestResult.scaledScore) {
                                                        selectedActivity.__analytics.bestResult.scaledScore = newInterpretedStatements[i].json.result.score.scaled;
                                                        selectedActivity.__analytics.bestResult.min = newInterpretedStatements[i].json.result.score.min;
                                                        selectedActivity.__analytics.bestResult.max = newInterpretedStatements[i].json.result.score.max;
                                                        selectedActivity.__analytics.bestResult.raw = newInterpretedStatements[i].json.result.score.raw;
                                                    }
                                                } else {
                                                    selectedActivity.__analytics.bestResult.scaledScore = newInterpretedStatements[i].json.result.score.scaled;
                                                    selectedActivity.__analytics.bestResult.min = newInterpretedStatements[i].json.result.score.min;
                                                    selectedActivity.__analytics.bestResult.max = newInterpretedStatements[i].json.result.score.max;
                                                    selectedActivity.__analytics.bestResult.raw = newInterpretedStatements[i].json.result.score.raw;
                                                }
                                            } else {
                                                selectedActivity.__analytics.bestResult = {
                                                    scaledScore: newInterpretedStatements[i].json.result.score.scaled,
                                                    min: newInterpretedStatements[i].json.result.score.min,
                                                    max: newInterpretedStatements[i].json.result.score.max,
                                                    raw: newInterpretedStatements[i].json.result.score.raw
                                                };
                                            }

                                            if (!selectedActivity.__analytics?.firstResult) selectedActivity.__analytics.firstResult = {};
                                            if (selectedActivity.__analytics.firstResult.scaledScore === undefined) {
                                                selectedActivity.__analytics.firstResult.scaledScore = selectedActivity.__analytics.bestResult.scaledScore;
                                                selectedActivity.__analytics.firstResult.min = selectedActivity.__analytics.bestResult.min;
                                                selectedActivity.__analytics.firstResult.max = selectedActivity.__analytics.bestResult.max;
                                                selectedActivity.__analytics.firstResult.raw = selectedActivity.__analytics.bestResult.raw;
                                            }
                                        }

                                        if (!selectedActivity.__analytics?.completedOnce) {
                                            selectedActivity.__analytics.completedOnce = true;
                                            if (selectedActivity['contributes-to-completion'] !== false) {
                                                // Updated Lesson level Analytics
                                                lessonId && selectedLesson.__analytics.itemCounts.completedAndContributeCompletion++;

                                                // Updated Unit level Analytics
                                                unitId && selectedUnit.__analytics.itemCounts.completedAndContributeCompletion++;
                                                if (
                                                    selectedActivity["sub-type"] == "ext-cup-xapiscoreable" ||
                                                    selectedActivity["sub-type"] == "ext-cup-scompscoreable"
                                                ) {
                                                    // Updated Lesson level Analytics
                                                    lessonId && selectedLesson.__analytics.itemCounts.completedOnceTestAndContributeCompletion++;
                                                    // Updated Unit level Analytics
                                                    unitId && selectedUnit.__analytics.itemCounts.completedOnceTestAndContributeCompletion++;
                                                }
                                            }
                                        }

                                        if (!selectedActivity.__analytics?.completedOnceWithSuccess && !ContentHelper.isTestContent(selectedActivity)) {
                                            selectedActivity.__analytics.completedOnceWithSuccess = true;
                                            if (selectedActivity['contributes-to-completion'] !== false) {
                                                // Updated Lesson level Analytics
                                                lessonId && selectedLesson.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;

                                                // Updated Unit level Analytics
                                                unitId && selectedUnit.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                            }
                                        }
                                        //Update completedOnceWithSucess if it is not present AND teacherScore is also missing 
                                        else if (
                                            !selectedActivity.__analytics?.completedOnceWithSuccess &&
                                            !selectedActivity.__analytics?.evaluationOverride &&
                                            selectedActivity["sub-type"] == "ext-cup-xapiscoreable" &&
                                            newInterpretedStatements[i].json?.result?.score?.hasOwnProperty('scaled') &&
                                            newInterpretedStatements[i].json.result.score.scaled >= selectedActivity["pass-score"]
                                        ) {
                                            selectedActivity.__analytics.completedOnceWithSuccess = true;
                                            if (selectedActivity['contributes-to-completion'] !== false && unitId && lessonId) {
                                                // Updated Lesson level Analytics
                                                selectedLesson.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                                selectedLesson.__analytics.itemCounts.completedWithSuccessTestAndContributeCompletion++;

                                                // Updated Unit level Analytics
                                                selectedUnit.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                                selectedUnit.__analytics.itemCounts.completedWithSuccessTestAndContributeCompletion++;
                                            }
                                        }
                                    }
                                } else if (verb.indexOf("submitted") !== -1) {
                                    if (newInterpretedStatements[i].json?.object?.id !== activityId) {
                                        // If completed statement of previous LO is called after the user has changed the LO, ignore that status
                                        return;
                                    }
                                } else if (verb.includes("experienced") && newInterpretedStatements[i].json?.result?.duration) {
                                    const parsedDuration = XAPIDataGenerator.convertTimespentToEpoc(newInterpretedStatements[i].json.result.duration);
                                    selectedActivity.__analytics.timespent = (selectedActivity.__analytics?.timespent ?? 0) + parsedDuration;
                                }
                                // Update the iconObj and scoreObj
                                this.updateLCHObjects(selectedActivity);
                                if (!this.chRef['destroyed']) {
                                    this.chRef.detectChanges();
                                }
                            }
                        }
                        //Post Statements to LRS via analytics engine if user is not a teacher
                        if (this.xapiLOAnalytics && !this.isPreviewMode) {
                            if (verb?.indexOf("submitted") !== -1 || (verb?.indexOf("completed") !== -1 && groupId)) {
                                // In case of submitted verb sent from pskill activities do not batch the calls
                                let options = {};
                                if (
                                    this.selectedItemData?.["sub-type"] === "cup-pskill" &&
                                    this.selectedItemData[this.selectedItemData["sub-type"]]?.["cup-options"]?.submissionType?.id === "speak"
                                ) {
                                    options = {
                                        isSignedURLReq: true,
                                        subType: "cup-pskill",
                                        submissionTypeId: "speak"
                                    };
                                }
                                this.xapiLOAnalytics.postStatementsNoBatch(newInterpretedStatements, options).then((response) => {
                                    this.showOrHideNextActivityButton();
                                    if (verb.indexOf("completed") !== -1) {
                                        this.productViewHelperService.collabSkillAnsSaved.next();
                                    }
                                    else {
                                        let responseEntity;
                                        if (response?.entities?.[0]) {
                                            responseEntity = response.entities[0];
                                        }
                                        let selectedResponseItem = this.getSelectedItemData(this.tocArray, responseEntity?.["item-code"]);
                                        let analyticsData;
                                        if (responseEntity?.["item-code"] && selectedResponseItem) {
                                            selectedResponseItem.__analytics.status = 'in_complete';
                                            selectedResponseItem.__analytics.lastSubmitted = new Date().getTime();
                                            selectedResponseItem.__analytics.submittedOnce = true;
                                            if (responseEntity.result?.response?.text) {
                                                analyticsData = { text: responseEntity.result.response.text };
                                                if (responseEntity.result.response.attribs?.title) {
                                                    analyticsData['attribs'] = {
                                                        'title': responseEntity.result.response.attribs.title
                                                    };
                                                }
                                                if (responseEntity.result.response?.link) {
                                                    analyticsData['link'] = responseEntity.result.response.link;
                                                }
                                            }
                                            if (responseEntity.result?.response?.audioPath) {
                                                analyticsData = { audioPath: responseEntity.result.response.audioPath };
                                            }
                                            // Update iconObj and scoreObj
                                            this.updateLCHObjects(selectedResponseItem);
                                        }
                                        this.productViewHelperService.pskillAnsSaved.next(analyticsData);
                                    }
                                }, (error) => {
                                    if (error.responseJSON?.errorCode === 'LINK_ERROR') {
                                        this.productViewHelperService.pskillUrlLinkValidation.next(error);
                                        return;
                                    }
                                    this.productViewHelperService.changesNotSaved.next();
                                });
                            } else if (verb?.indexOf("submitted") === -1) {
                                this.xapiLOAnalytics.postStatements(newInterpretedStatements);
                            }
                        }

                    } catch (error) {
                        if (foundCompletedStatement) {
                            const localStorageInfo = this.analyzeLocalStorage(error);
                            this.logInfoToBackend('TYPE=ACTIVITY_COMPLETION_ERROR;MicroAPP', {
                                newInterpretedStatements,
                                ...localStorageInfo,
                                timings: this.productViewHelperService.getActivityTiming(activityId),
                                errorMessage: error.message,
                                errorStack: error.stack,
                                errorObject: JSON.stringify(error)
                            });
                        }
                        throw error;
                    }
                },
                containerNotification: (uniqueId, containerEvent, containerEventData) => {
                    // These events are needed in SPA LOs(for Progress Bar) and SComp LOs(for Activity Controls)
                    const activityEventsToBePassed = [
                        'container_controls',
                        'currentScreen',
                        'totalScreens',
                        'activityClosed',
                        'fullScreen',
                        'showExitConfirmationModal'
                    ];

                    if (
                        (
                            this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'spa-container' ||
                            this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'scomp-container'
                        ) && activityEventsToBePassed.indexOf(containerEvent) > -1
                    ) {
                        this.productViewHelperService.activityEventsSubject.next({ uniqueId, containerEvent, containerEventData });
                    }
                    if (containerEvent === 'avallain_controls' || containerEvent === 'generic_controls') {
                        this.showControls = this.productViewHelperService.handleControlEvent(
                            this.showControls,
                            containerEvent,
                            containerEventData,
                            this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'scomp-container',
                            false,
                            this.nextActivityBtn
                        );
                    } else if (containerEvent === 'iframeEvents') {
                        if (this.learningpathVisible === true) {
                            this.learningpathVisible = false;
                        }
                    } else if (containerEvent === 'container_controls') {
                        if (containerEventData === 'activityCompleted') {
                            this.showOrHideNextActivityButton();
                        }
                    } else if (containerEvent === "activityClosed") {
                        // hide C1 result screen if rendered
                        this.hideResultScreen();
                        /*launch next activity or Show TOC and relaunch (for games) if content terminates itself
                        ignore activityClosed event if close called by conatiner (logout, navigate to dashboard and click on 'tryAgain' button scenarios) */
                        if (!containerEventData?.isContainerCloseCalled && uniqueId === this.selectedItem.activityId) {
                            if (this.isGameActivity) {
                                /* Show TOC and relaunch game activity on click of 'Exit Game' */
                                if (!this.learningpathVisible) this.learningpathVisible = true;
                                this.relaunchActivity();
                            } else {
                                this.launchNextActivity?.nativeElement?.click();
                            }
                        }
                    } else if (containerEvent === 'showResults') {
                        this.showResultScreenEvent.next(containerEventData);
                        this.showResultScreen = true;
                    } else if (containerEvent === 'showNextActivity') {
                        this.showOrHideNextActivityButton(containerEventData);
                    }
                    this.chRef.detectChanges();
                }
            }

            // Initialize the Activity & setup event handlers.
            this.productViewHelperService.setXAPIRunnerObject(initParams, eventCallbacks);

            // For non-LPv4 products, if no item is selected in route, open particular item on the basis of status of recently accessed item
            // In case of assignments of all products, if no item is selected in route, open the assignment item
            if ((!this.isLPv4Product || this.assignmentId) && !this.route.firstChild?.snapshot?.params?.itemid) {
                if (this.productTocData?.toc?.navigationMeta?.length > 0) {
                    let itemid;
                    //NavigationArray : array containing all resources
                    let navigationArray = this.productTocData.toc.navigationMeta;
                    let recentlyAccessedItem;
                    // Find recentlyAccessedItem from UP if only one unit is accessible to learner
                    if (this.accessibleUnitCode) {
                        if(this.accessibleActivityId) {
                            // Open the accessibleActivityId itself since only 1 activity needs to be shown
                            recentlyAccessedItem = this.accessibleActivityId;
                        } else {
                            let recentlyAccessedItemTs = 0;
                            const findLastAccessedItem = (items) => {
                                if (items) {
                                    items.forEach( item => {
                                        if (item.items) {
                                            findLastAccessedItem(item.items);
                                        } else if (item.__analytics?.lastAccessed > recentlyAccessedItemTs) {
                                            recentlyAccessedItemTs = item.__analytics.lastAccessed;
                                            recentlyAccessedItem = item['item-code'];
                                        }
                                    });
                                }
                            }
                            findLastAccessedItem(this.productTocData.toc.tocArray.result);
                        }
                        // For other cases, find recentlyAccessedItem from APP State if it exists
                    } else if(this.appState) {
                        if(this.assignmentId) {
                            // Recent item coresponding to the assignment id
                            recentlyAccessedItem = this.appState['recentlyAccessedItem-' + this.assignmentId];
                        } else {
                            // Recent item coresponding to class/product
                            recentlyAccessedItem = this.appState.recentlyAccessedItem;
                        }
                    }
                    
                    if(!this.isPreviewMode && recentlyAccessedItem) { 
                        //Find index of most recently accessed Item in NavigationArray
                        const recentlyAccessedItemIndex = navigationArray.map(
                            (val) => val["item-code"]).indexOf(recentlyAccessedItem);
                        // In case the book gets updated, the last stored recentlyAccessedItem is 
                        // no longer in the new book structure then open the first index item in the book
                        if (recentlyAccessedItemIndex === -1) {
                            itemid = navigationArray[0]["item-code"];
                        } else {
                            // If status of most recently accessed Item is completed and it is not the last item of product
                            // and it is non downloadable LO , Launch the next item/LO
                            if (recentlyAccessedItemIndex !== (navigationArray.length - 1) &&
                                navigationArray?.[recentlyAccessedItemIndex]?.__analytics?.status == 'completed' 
                            && !(ContentHelper.isDownloadableContent(navigationArray[recentlyAccessedItemIndex]))) {
                                itemid = navigationArray[recentlyAccessedItemIndex + 1]["item-code"];                             
                            } else { //In all other cases launch the most recently accessed Item
                                itemid = recentlyAccessedItem;
                            }    
                        }   
                    } else { 
                        if(this.accessibleActivityId) {
                            // If user is a teacher but has activityId in params, open the accessibleActivityId itself
                            itemid = this.accessibleActivityId;
                        } else {
                            //If API does not return any item or user is a teacher, Launch first resource in TOC
                            itemid = navigationArray[0]["item-code"];
                        }
                    }
                    this.navigateToChild(itemid);     
                }
            } else if (!this.isLPv4Product || this.isTeacherViewAssignment) {
                // Find which unit to be set to active
                this.findUnitSelected(decodeURIComponent(this.route.firstChild.snapshot.params.itemid));
            }

            //important, subscribe and handle change in item 
            this.selectedItemSubscription = this.productViewHelperService.selectedItemId.subscribe(
                (selectedItemObject: any) => {
                    if (
                        this.selectedItem?.activityId &&
                        this.productViewHelperService.existsActivityTiming(this.selectedItem.activityId)
                    ) {
                        this.productViewHelperService.addActivityTiming(this.selectedItem.activityId, 'gotNextItem');
                    }
                // Hide all activity buttons by default when new activity launches
                this.showControls = [];
                this.selectedItem = selectedItemObject?.selectedItem ?? {};
                this.selectedItemData = selectedItemObject?.selectedItemData;

                if (!selectedItemObject) return;

                this.findUnitSelected(selectedItemObject.itemid);

                // Show Next button immediately in download type activities
                setTimeout(()=> {
                    if (this.selectedItemData['accessInfo'].isLocked) {
                        this.showOrHideNextActivityButton();
                    } else {
                        this.isGameActivity = selectedItemObject.selectedItemData['game'] ? true : false;
                        if (ContentHelper.isDownloadableContent(selectedItemObject.selectedItemData)) {
                            // Do not show next button in case Downloadable activity is the last activity of the product
                            this.showOrHideNextActivityButton();
                        } else if (
                            !this.isPreviewMode &&
                            ContentHelper.isSubmittableContent(selectedItemObject.selectedItemData) &&
                            selectedItemObject.selectedItemData?.__analytics?.submittedOnce &&
                            (
                                !selectedItemObject.selectedItemData.__analytics?.['reattempt-requested'] ||
                                selectedItemObject.selectedItemData.__analytics?.submitCount >= 3
                            )
                        ) {
                            this.showOrHideNextActivityButton();
                        }
                        else if (
                            !this.isPreviewMode &&
                            ContentHelper.isCollaborativeTask(selectedItemObject.selectedItemData) &&
                            selectedItemObject.selectedItemData.__analytics?.completedOnce
                        ) {
                            this.showOrHideNextActivityButton();
                        } else if (this.isPreviewMode && ContentHelper.isSubmittableContent(selectedItemObject.selectedItemData)) {
                            this.showOrHideNextActivityButton();
                        } else if (this.isPreviewMode && ContentHelper.isCollaborativeTask(selectedItemObject.selectedItemData)) {
                            this.showOrHideNextActivityButton();
                        } else {
                            this.nextActivityBtn.show = false;
                        }
                    }  
                });                
            });

            this.isLitmusAvailable = this.productTocData?.serviceAvailabilityFlags?.litmusAvailable;

            if (!this.isLitmusAvailable && !(this.productTocData?.orgId && this.appHelperService.checkMQAUsingDlsOrgId(this.productTocData.orgId))) {
                let isAnyNonLitmusTypeActivity;
                if (this.assignmentData) {
                    isAnyNonLitmusTypeActivity = this.isAnyNonLitmusTypeActivity(this.assignmentData.items);
                }
                else {
                    isAnyNonLitmusTypeActivity = this.isAnyNonLitmusTypeActivity(this.tocArray.result);
                }

                this.showLitmusUnavailableScreen = !isAnyNonLitmusTypeActivity;
            }

            if (this.userData?.role === 'student' && this.userData.launchType !== 'lti') {
                try {
                    // logging product viewed event
                    const userData = {
                        user: this.userData,
                        productCode: this.productCode,
                        classId: this.classId,
                        assignmentId: this.assignmentId,
                        orgId: this.productTocData.orgId
                    }
                    const loginEvent = this.trackUserService.generateProductViewedEvent(userData);
                    this.trackUserService.logEvents([loginEvent]);
                }
                catch (e) {
                    // do nothing just logging
                    console.log(e);
                }
            }
        });

        /** 
         * Subscribe to router navigation events to track LPv4 activity state changes.
         * This subscription monitors when activities are launched or closed in LPv4 products.
         * In case of LPv4 product assignments, no need to track activity launch state or initialising LPv4 product view.
         */
        if (this.isLPv4Product && !this.assignmentId) {
            this.childParamsSubscription = this.router.events.pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    // Get the child route parameters
                    const childParams = this.route.firstChild?.snapshot.params;
                    return childParams;
                })
            ).subscribe((childParams) => {
                if (childParams?.itemid) {
                    this.isActivityLaunched = true;
                } else {
                    const state = this.router.getCurrentNavigation()?.extras?.state;
                    // Check from router state if we need to reset the LPv4 view
                    this.productViewV4.initialiseView(!!state?.['resetLPv4View']);
                    this.isActivityLaunched = false;
                }
            });
        }
    }

    /* Function to get selected item data  */
    private getSelectedItemData(toc, itemId) {
        let activityItems = [];
        let selectedItemData;
        toc.result.some((unit, unitIndex) => {
            activityItems = this.productTocService.getLeafNodeItems(unit);
            selectedItemData = activityItems.find((activity) => {
                let itemCode = decodeURIComponent(activity['item-code']);
                return (itemId === itemCode);
            })
            return selectedItemData;
        });
        return selectedItemData;
    }

    /**
     * Sets next activity button if not last item
     * @param scompEventData - Boolean value to switch the next activity button. Passed only for SComp activities
     */
    showOrHideNextActivityButton (scompEventData?: boolean) {
        const isScompContent = this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'scomp-container';
        if (isScompContent) {
            // For non-assignment SComp activities, show 'See topics' button instead of 'Next activity' button
            if (scompEventData === true && !this.assignmentId) {
                this.showControls.push({
                    'containerType': 'generic_controls',
                    'type': 'seeTopics',
                    'text': 'LEARNER.ACTIVITYLAUNCH.SEE_TOPICS',
                    'isSecondary': this.showControls.length !== 0,
                    'isActive': true
                });
                return;
            } else if (scompEventData === false) {
                this.nextActivityBtn.show = false;
                this.showControls = this.showControls.filter(control => control.type !== 'seeTopics');
                return;
            }
        }

        let navigationArray = this.productTocData.toc.navigationMeta;
        let currentItemIndex = navigationArray.map( (val) => val["item-code"] ).indexOf(this.selectedItem.activityId);
        if ( currentItemIndex !== navigationArray.length-1) {
            this.nextActivityBtn.show = true;
            this.nextActivityBtn.type = 'nextActivity';
        } else if (isScompContent && this.assignmentId) {
            // For SComp assignments, show 'Back to assignments' button on last activity
            this.nextActivityBtn.show = true;
            this.nextActivityBtn.type = 'backToAssignments';
        } else {
            this.nextActivityBtn.show = false;
        }
    }

    findUnitSelected (itemid): void {
        let unitid = itemid.split('/')[0];
        for(var index=0; this.tocArray.result && index<this.tocArray.result.length; index++) {            
            if (this.tocArray.result[index]?.['item-code'] === unitid) {
                this.selectedItem.selectedUnitIndex = index;
                break;
            }
        }
    }

    navigateToChild(itemid) {
        if(this.previewMode) {
            this.router.navigate(["item", itemid], { relativeTo: this.route, queryParams: { preview: true, stage : this.previewStage }, replaceUrl: true});
        } else {
            const requiredQueryParams = this.appHelperService.getRequiredQueryParams(this.route.snapshot.queryParams, ['lf', 'cid', 'bcode', 'rcode', 'ltik', 'ltiGiId']);
            this.router.navigate(["item", itemid], { relativeTo: this.route, replaceUrl: true, queryParams: requiredQueryParams });
        }
    }

    /* Function to action content controls - checkAnswer/goNext/goToExerciseScreen/sendScores etc. */
    public actionControl({containerType, type}) {
        // Hide C1 result screen if rendered
        this.hideResultScreen();

        if(type === 'goToExerciseScreen' || type === 'reviewAnswers' || type === 'goPrev') {
            this.nextActivityBtn.show = false;
        }

        // For Scomp content, on 'See topics' click, close the LO.
        if (
            this.selectedItemData?.[this.selectedItemData["sub-type"]]?.container === 'scomp-container' &&
            type === 'seeTopics'
        ) {
            this.loaderService.showOverlayLoader();

            // Navigate to parent route (product view without any activity launched)
            // Pass state to reset LPv4 view
            const requiredQueryParams = this.appHelperService.getRequiredQueryParams(this.route.snapshot.queryParams, ['lf', 'cid', 'bcode', 'rcode', 'ltik', 'ltiGiId']);
            this.router.navigate(['../../'], { relativeTo: this.route.firstChild, state: { resetLPv4View: true }, queryParams: requiredQueryParams });
            return;
        }

        // Action Control
        this.productViewHelperService.getXAPIRunnerObject().containerInvocation(this.selectedItem.activityId, containerType, { type });
    }

    nextActivity() {
        if (!this.nextActivityBtn.show) {
            return;
        }
        this.loaderService.showOverlayLoader();
        let navigationArray = this.productTocData.toc.navigationMeta;
        let currentItemIndex = navigationArray.map( (val) => val["item-code"] ).indexOf(this.selectedItem.activityId);
        // Check if next button was pressed on last activity
        if (currentItemIndex !== navigationArray.length-1 && navigationArray[currentItemIndex+1]) {
            this.navigateToChild(navigationArray[currentItemIndex+1]?.['item-code']);
        }        
    }

    // Function to hide C1 rendered result screen
    hideResultScreen() {
        if (this.showResultScreen) {
            this.showResultScreen = false;
        }
    }
    
    // Function to relaunch activity
    relaunchActivity() {
        this.showControls = [];
        this.nextActivityBtn.show = false;
        this.productViewHelperService.getXAPIRunnerObject().reLaunchLO(this.selectedItem.activityId);
    }

    hideSidebar($event) {
        if (
            typeof ($event.target?.className) === "string" &&
            $event.target.className.indexOf('open-sidebar-btn') === -1 &&
            $event.target?.parentNode &&
            typeof ($event.target.parentNode?.className) === "string" &&
            $event.target.parentNode.className.indexOf('open-sidebar-btn') === -1
        ) {
            this.learningpathVisible = false;
        }        
    }

    /* Function to return true for all control types for which control needs to be shown in green */
    isControlToBeShownGreen(type) {
        switch (type) {
            case 'checkAnswer':
            // case 'goNext':
            case 'goToExerciseScreen':
            // case 'sendScores':
            case 'checkAnswers':
            case 'reviewAnswers':
            // case 'goPrev': 
            return true;
            default: return false;
        }
    }

    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.productViewHelperService.terminateActivityView();
    }

    ngOnDestroy() {
        this.paramsSubscription.unsubscribe();
        this.selectedItemSubscription.unsubscribe();
        this.childParamsSubscription?.unsubscribe();
        // Removed xapiLOAnalytics object so that no analytics call is made when user is leaves product-view component
        this.xapiLOAnalytics = undefined;
    }

    /* Function to update 'libs-content-helper' icon and score objects */
    updateLCHObjects(activity){
        this.productViewDataService.getProductContentHelper().updateAnalyticsAsPerClassCustomisations(activity);
        activity.lchObject.iconObj = this.productViewDataService.getProductContentHelper().getStatusIconForContent(activity);
        activity.lchObject.scoresObj = this.productViewDataService.getProductContentHelper().getFormattedScore(activity);
    }

    isAnyNonLitmusTypeActivity(items) {
        if (!items) return;

        return items.some(unit => {
            let activityItems = this.productTocService.getLeafNodeItems(unit);
            return activityItems.some(activity => {
                const itemSubType = activity?.["sub-type"];
                const itemToolRef = itemSubType && activity[itemSubType]?.['tool-ref'];
                return ltiToolRefs.indexOf(itemToolRef) === -1;
            })
        });
    }

    private logInfoToBackend(context: string, data: any = {}) {
        this.customBackendLoggerService.logInfoToBackend({
            context,
            extUserId: this.userProfileData.extUserId,
            spaceId: this.apiGatewayHelperService.getSpaceId(),
            classId: this.classId,
            productCode: this.productCode,
            data: {
                itemCode: this.selectedItem.activityId,
                ...data
            },
            isUserInfoNeeded: true,
        }).toPromise();
    }

    private analyzeLocalStorage(errorObject) {
        try {
            if (!errorObject || errorObject.name !== 'QuotaExceededError') {
                return {};
            }
            return Object.keys(window.localStorage).reduce((acc, key) => {
                const s = key.length + window.localStorage.getItem(key)?.length;
                acc.lsKeys.push({ k: key, s });
                acc.lsTotal += s;
                return acc;
            }, { lsTotal: 0, lsKeys: [] });
        } catch (err) {
            return { lsError: err?.message || err };
        }
    }
}